module.exports = __webpack_public_path__ + "static/img/bg5.7522ad32.png";